import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import api from "@/services/api"
import dynamodb from "aws-sdk/clients/dynamodb"

Vue.use(Vuex)

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: state => ({ productFilterTypes: state.productFilterTypes })
})

export default new Vuex.Store({
  plugins: [vuexSession.plugin],
  state: {
    site_id: "southgate",
    homeID: "osESjUCDQ",
    contactID: "JijNUa8qf",
    careersID: "94gQ_fgyQ",
    servicesID: "Bfye7OjyU",
    newsID: "j8NsTTI7V",
    partnersID: "Dt6hRab7c",
    productsID: "h8B7efpk2",
    projectsID: "N9yzS4_hh",
    get withoutBannersOrMainText() {
      return [this.productsID, this.contactID, this.newsID, this.servicesID]
    },
    get withoutBannersOrMainTextByType() {
      return ["page.categories=", "page.articles="]
    },
    page: {},
    projcat: "",
    projsec: "",

    sitemap: null,
    services: null,
    partners: null,
    spec_icons: null,
    fitting_attributes: null,
    categories: null,
    main_pages: null,
    latest_articles: null,
    articles: null,
    projects: null,
    latest_products: null,
    featured_products: null,
    featured_projects: null,
    settings: null,
    contact_page: null,
    careers_page: null,
    projects_page: null,

    productFilterTypes: {}
  },
  getters: {
    numberofpages: () => (array, page_size) => {
      return Math.ceil(array.length / page_size)
    },
    page: () => (array, page_size, page_number) => {
      --page_number
      return array.slice(page_number * page_size, (page_number + 1) * page_size)
    },
    catByID: state => ItemID => {
      if (!state.categories) return {}
      // No array.find in IE
      var index = -1
      for (var i = 0; i < state.categories.length; ++i) {
        if (state.categories[i].ItemID == ItemID) {
          index = i
          break
        }
      }
      if (index > -1) return state.categories[index]
      else return {}
    }
  },
  mutations: {
    setFilter(state, filter) {
      state.productFilterTypes = filter
    },
    resetFilter(state) {
      state.productFilterTypes = {}
    },
    setPage(state, page) {
      state.page = page
    },
    setProjCat(state, projcat) {
      state.projcat = projcat
    },
    setProjSec(state, projsec) {
      state.projsec = projsec
    },
    setSitemap(state, sitemap) {
      state.sitemap = sitemap
    },
    setSettings(state, settings) {
      state.settings = settings
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    setContactPage(state, contact_page) {
      state.contact_page = contact_page
    },
    setCareersPage(state, careers_page) {
      state.careers_page = careers_page
    },
    setProjectsPage(state, projects_page) {
      state.projects_page = projects_page
    },
    setServices(state, services) {
      state.services = services
    },
    setLatestArticles(state, latest_articles) {
      state.latest_articles = latest_articles
    },
    setArticles(state, articles) {
      state.articles = articles
    },
    setProjects(state, projects) {
      state.projects = projects
    },
    setFeaturedProducts(state, featured_products) {
      state.featured_products = featured_products
    },
    setFeaturedProjects(state, featured_projects) {
      state.featured_projects = featured_projects
    },
    setLatestProducts(state, latest_products) {
      state.latest_products = latest_products
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages
    },
    setPartners(state, partners) {
      state.partners = partners
    },
    setSpecIcons(state, spec_icons) {
      state.spec_icons = spec_icons
    },
    setFittingAttributes(state, fitting_attributes) {
      state.fitting_attributes = fitting_attributes
    }
  },
  actions: {
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPagesPOST("page.main").then(main_pages => {
            commit("setMainPages", main_pages)
            resolve()
          })
        else resolve()
      })
    },
    getServices({ commit, state }) {
      return new Promise(resolve => {
        if (!state.services)
          api.getPagesPOST("page.services", "", "", "", "image").then(services => {
            commit("setServices", services)
            resolve()
          })
        else resolve()
      })
    },
    getCategories({ commit, state }) {
      return new Promise(resolve => {
        if (!state.categories)
          api.getPagesPOST("page.categories", "", "", "", "colour,font_colour").then(categories => {
            commit("setCategories", categories)
            resolve()
          })
        else resolve()
      })
    },
    getLatestArticles({ commit, state }) {
      return new Promise(resolve => {
        if (!state.latest_articles)
          api.getPagesPOST("page.articles", "", "", "", "images", false).then(latest_articles => {
            commit("setLatestArticles", latest_articles.slice(0, 4))
            resolve()
          })
        else resolve()
      })
    },
    getArticles({ commit, state }) {
      return new Promise(resolve => {
        if (!state.articles)
          api.getPagesPOST("page.articles", "", "", "", "images,intro,meta_desc", false).then(articles => {
            commit("setArticles", articles)
            resolve()
          })
        else resolve()
      })
    },
    getProjects({ commit, state }) {
      return new Promise(resolve => {
        if (!state.projects)
          api
            .getPagesPOST("page.projects", "", "", "", "images,intro,meta_desc,category,sector", false)
            .then(projects => {
              commit("setProjects", projects)
              resolve()
            })
        else resolve()
      })
    },
    getFeaturedProducts({ commit, state }) {
      return new Promise(resolve => {
        if (!state.featured_products)
          api
            .getPagesPOST(
              "page.products",
              "",
              { "#featured": "featured" },
              "#featured = :true",
              "images,categories,fitting_attributes_list"
            )
            .then(featured_products => {
              commit(
                "setFeaturedProducts",
                featured_products.sort((a, b) => a.name.localeCompare(b.name))
              )
              resolve()
            })
        else resolve()
      })
    },
    getCategoryProducts({ }, categoryID) {
      return new Promise((resolve, reject) => {
        api
          .getPagesPOST(
            "page.products",
            { ":catid": dynamodb.Converter.input(categoryID) },
            { "#categories": "categories", "#images": "images" },
            "contains(#categories,:catid)",
            "#images,fitting_attributes_list"
          )
          .then(products => {
            resolve(products.sort((a, b) => a.name.localeCompare(b.name)))
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getCategoryPDFProducts({ commit, state }, categoryID) {
      return new Promise(resolve => {
        api
          .getPagesPOST(
            "page.livepdfproducts",
            { ":catid": dynamodb.Converter.input(categoryID) },
            { "#categories": "categories" },
            "contains(#categories,:catid)",
            "*"
          )
          .then(products => {
            if (state.page.ItemID == "h8B7efpk2")
              resolve(products.filter(p => p.categories[0] == categoryID).sort((a, b) => a.name.localeCompare(b.name)))
            else resolve(products.sort((a, b) => a.name.localeCompare(b.name)))
          })
      })
    },
    getSearchProducts({ }, query) {
      return new Promise(resolve => {
        api
          .getPagesPOST(
            "page.products",
            { ":query": dynamodb.Converter.input(query.toLowerCase()) },
            {
              "#images": "images",
              "#search": "_search"
            },
            "contains(#search,:query)",
            "#images,categories,fitting_attributes_list"
          )
          .then(products => {
            resolve(products.sort((a, b) => a.name.localeCompare(b.name)))
          })
      })
    },
    getAttributeProducts({ }, attrID) {
      return new Promise(resolve => {
        api
          .getPagesPOST(
            "page.products",
            { ":attrid": dynamodb.Converter.input(attrID) },
            {
              "#fitting_attributes_list": "fitting_attributes_list",
              "#images": "images"
            },
            "contains(#fitting_attributes_list,:attrid)",
            "#images,#fitting_attributes_list"
          )
          .then(products => {
            resolve(products.sort((a, b) => a.name.localeCompare(b.name)))
          })
      })
    },
    getProjectsByProduct({ }, prodID) {
      return new Promise(resolve => {
        api
          .getPagesPOST(
            "page.projects",
            { ":prodid": dynamodb.Converter.input(prodID) },
            {
              "#products": "products",
              "#images": "images"
            },
            "contains(#products,:prodid)",
            "#images"
          )
          .then(projects => {
            resolve(projects)
          })
      })
    },
    getProductsByFamily({ }, family) {
      return new Promise(resolve => {
        api
          .getPagesPOST(
            "page.products",
            { ":family": dynamodb.Converter.input(family) },
            {
              "#family": "family",
              "#images": "images"
            },
            "contains(#family,:family)",
            "#images,categories,fitting_attributes_list"
          )
          .then(products => {
            resolve(products)
          })
      })
    },
    getFeaturedProjects({ commit, state }) {
      return new Promise(resolve => {
        if (!state.featured_projects)
          api
            .getPagesPOST("page.projects", "", "", "featured = :true", "banner_image,meta_desc,images")
            .then(featured_projects => {
              commit("setFeaturedProjects", featured_projects)
              resolve()
            })
        else resolve()
      })
    },
    getLatestProducts({ commit, state }) {
      return new Promise(resolve => {
        if (!state.latest_products)
          api
            .getPagesPOST("page.products", "", { "#latest": "latest" }, "#latest = :true", "images,categories")
            .then(latest_products => {
              commit(
                "setLatestProducts",
                latest_products.sort((a, b) => a.name.localeCompare(b.name))
              )
              resolve()
            })
        else resolve()
      })
    },
    getSettings({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api.getPageByItemID("SETTINGS").then(settings => {
            commit("setSettings", settings)
            resolve()
          })
        else resolve()
      })
    },
    getContactPage({ commit, state }) {
      return new Promise(resolve => {
        if (!state.contact_page)
          api.getPageByItemID(state.contactID, "ItemID,name,url,hide").then(contact_page => {
            commit("setContactPage", contact_page)
            resolve()
          })
        else resolve()
      })
    },
    getCareersPage({ commit, state }) {
      return new Promise(resolve => {
        if (!state.careers_page)
          api.getPageByItemID(state.careersID, "ItemID,name,url,hide").then(careers_page => {
            commit("setCareersPage", careers_page)
            resolve()
          })
        else resolve()
      })
    },
    getProduct({ }, prodID) {
      return new Promise(resolve => {
        api.getPageByItemID(prodID, "ItemID,name,url,images,active,categories,hide").then(product => {
          if (!product.hide) resolve(product)
          else resolve({})
        })
      })
    },
    getProjectsPage({ commit, state }) {
      return new Promise(resolve => {
        if (!state.projects_page)
          api.getPageByItemID(state.projectsID, "ItemID,name,url,meta_desc").then(projects_page => {
            commit("setProjectsPage", projects_page)
            resolve()
          })
        else resolve()
      })
    },
    getPartners({ commit, state }) {
      return new Promise(resolve => {
        if (!state.partners)
          api.getPageByItemID("PARTNERS", "items").then(partners => {
            commit("setPartners", partners.items)
            resolve()
          })
        else resolve()
      })
    },
    getSpecIcons({ commit, state }) {
      return new Promise(resolve => {
        if (!state.spec_icons)
          api.getPageByItemID("SPECICONS", "items").then(spec_icons => {
            commit("setSpecIcons", spec_icons.items)
            resolve()
          })
        else resolve()
      })
    },
    getFittingAttributes({ commit, state }) {
      return new Promise(resolve => {
        if (!state.fitting_attributes)
          api.getPageByItemID("FITTINGATTRIBUTES", "items").then(fitting_attributes => {
            commit("setFittingAttributes", fitting_attributes.items)
            resolve()
          })
        else resolve()
      })
    }
  }
})
